// extracted by mini-css-extract-plugin
module.exports = {"bestPropertyTag":"styles_bestPropertyTag__E0wVP system_captionL__E1FNu","branded":"styles_branded__f8aff"};